import type { ITerm } from "store/managementStore";

import type { IWork } from "./types";

type TermWorkFields = Pick<ITerm, "workId" | "title"> & {
    titleAvatarUrl?: string | null;
    avatarUrl?: string | null;
};

export const coverUrlForWork = (work: IWork | null | undefined): string | undefined =>
    work?.avatarUrl ?? work?.titles?.find((title) => title.avatarUrl)?.avatarUrl ?? undefined;

export const workDisplayLabel = (work: { name: string; workCode?: string | null } | null | undefined): string => {
    const name = work?.name ?? "";
    const workCode = work?.workCode?.trim();
    return workCode ? `${name} (${workCode})` : name;
};

export const workPreviewFromTerm = (
    term: TermWorkFields | null | undefined,
    selectedWork: IWork | null = null,
): IWork | null => {
    if (term?.workId == null) return null;
    if (selectedWork?.id === term.workId) return selectedWork;

    const name = term.title || selectedWork?.name || "";
    if (!name) return null;

    return {
        id: term.workId,
        name,
        workCode: selectedWork?.workCode ?? null,
        companyId: selectedWork?.companyId ?? 0,
        artworkNature: selectedWork?.artworkNature ?? null,
        analysisCode: selectedWork?.analysisCode ?? null,
        associatedBrand: selectedWork?.associatedBrand ?? null,
        compensationGroupId: selectedWork?.compensationGroupId ?? null,
        avatarUrl: selectedWork?.avatarUrl ?? term.titleAvatarUrl ?? term.avatarUrl ?? null,
        createdAt: selectedWork?.createdAt ?? "",
        updatedAt: selectedWork?.updatedAt ?? "",
        titles: selectedWork?.titles ?? [],
    };
};
